import { Menu } from '../menu';
import { ProductSection } from './product-section';

export class PlantlifeOneColumnProductSection extends ProductSection {
  getBorderColor(menu: Menu): string {
    return menu?.menuOptions?.bodyBackgroundColor;
  }
}
